<template>
  <v-container class="in-journey-accordion">
    <div
      class="in-journey-accordion-container"
      v-for="(item, index) in accordionData"
      :key="index"
    >
      <div
        v-if="item.masterTitle"
        :style="{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }"
        class="master-title-section"
      >
        <div>
          <h1>{{ item.masterTitle }}</h1>
        </div>
      </div>
      <div
        class="title-section"
        :style="{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }"
      >
        <div class="title-section-left">
          <h1>{{ item.title }}</h1>
          <h2 v-if="item.subtitle">{{ item.subtitle }}</h2>
        </div>
        <p v-if="item.price !== undefined">R {{ item.price | currency }}</p>
      </div>
      <div
        v-if="!item.alwaysExpanded"
        class="see-more-section"
        :style="{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }"
        @click="expandClicked(index)"
      >
        <p v-if="expandedIndex !== index">See more</p>
        <div v-if="expandedIndex !== index" class="chevron-container">
          <v-img
            aspect-ratio="0.95"
            :src="require('@/assets/shared/redesign/common/chevron_down.svg')"
          />
        </div>
      </div>
      <div
        class="content-section"
        v-if="expandedIndex == index || item.alwaysExpanded"
      >
        <div
          class="content-body"
          :style="{
            paddingLeft: `${padding}px`,
            paddingRight: `${padding}px`,
          }"
        >
          <div class="paragraph-section" v-if="item.content?.paragraph">
            <p>{{ item.content.paragraph }}</p>
          </div>
          <div
            v-if="item.content?.headerAndTitles"
            v-for="(headerAndTitleItem, index) in item.content.headerAndTitles"
            :key="index"
            class="header-and-title-section"
            :class="{ 'indented-header-and-title': item.content.indented }"
          >
            <div
              v-if="item.content.reversed"
              class="title-part"
              :class="{ 'small-gap': headerAndTitleItem.smallHeader }"
            >
              <h1
                v-if="headerAndTitleItem.header"
                v-html="headerAndTitleItem.header"
              ></h1>
              <p v-if="headerAndTitleItem.price !== undefined">
                R {{ headerAndTitleItem.price | currency }}
              </p>
            </div>

            <div class="subtitle" v-if="headerAndTitleItem.description">
              <p>
                {{ headerAndTitleItem.description }}
              </p>
              <div class="column-mimic"></div>
            </div>
            <div
              v-if="!item.content.reversed"
              class="title-part"
              :class="{ 'small-gap': headerAndTitleItem.smallHeader }"
            >
              <h1
                :class="{ 'small-title-part': headerAndTitleItem.smallHeader }"
                v-if="headerAndTitleItem.header"
                v-html="headerAndTitleItem.header"
              ></h1>

              <p v-if="headerAndTitleItem.price !== undefined">
                R {{ headerAndTitleItem.price | currency }}
              </p>
              <div v-else class="column-mimic"></div>
            </div>
          </div>

          <div
            v-if="!item.alwaysExpanded"
            class="see-less-section"
            :class="{ 'see-less-indented': item.seeLessIndented }"
            @click="expandClicked(index)"
          >
            <p v-if="expandedIndex === index">See less</p>
            <div
              v-if="expandedIndex === index"
              class="chevron-container upwards"
            >
              <v-img
                aspect-ratio="0.95"
                :src="
                  require('@/assets/shared/redesign/common/chevron_down.svg')
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="header-container"
        :style="{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }"
        v-if="item.content?.headerContainer"
      >
        <h1 v-if="item.content?.headerContainer?.title">
          {{ item.content.headerContainer.title }}
        </h1>
        <div
          v-if="item.content?.headerContainer?.price !== undefined"
          class="header-price"
        >
          <h1>R {{ item.content.headerContainer.price | currency }}</h1>
        </div>
      </div>
      <div
        class="header-container-content-body"
        :style="{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }"
      >
        <div class="content-title" v-if="item.content?.title">
          <p>{{ item.content.title }}</p>
        </div>
        <div class="bullets-container" v-if="item.content?.bullets">
          <ul>
            <li v-for="(bullet, index) in item.content.bullets" :key="index">
              {{ bullet }}
            </li>
          </ul>
        </div>
      </div>
      <div
        class="separator-container"
        :style="{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }"
      >
        <div
          v-if="index !== accordionData.length - 1 || summarySection"
          class="separator"
        ></div>
      </div>
    </div>
    <div
      v-if="summarySection"
      class="summary-section"
      :style="{
        paddingLeft: `${padding}px`,
        paddingRight: `${padding}px`,
      }"
    >
      <div>
        <InJourneyAccordionSummary
          @summaryClicked="summaryClicked"
          :summary="summarySection"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
  import InJourneyAccordionSummary from './InJourneyAccordionSummary.vue';
  export default {
    name: 'InJourneyAccordion',
    components: {
      InJourneyAccordionSummary,
    },
    props: {
      accordionData: {
        required: true,
        default: [],
        type: Array,
      },
      summarySection: {
        required: false,
        default: null,
        type: Object,
      },
      padding: {
        required: true,
        default: 0,
        type: Number,
      },
    },
    data() {
      return {
        expandedIndex: null,
      };
    },
    methods: {
      expandClicked(index) {
        if (index == this.expandedIndex) {
          this.expandedIndex = null;
        } else {
          this.expandedIndex = index;
        }
      },
      summaryClicked() {
        this.$emit('summaryClicked');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .column-mimic {
    min-width: 102px;
  }
  .in-journey-accordion {
    width: 100%;
    padding: 0;

    .in-journey-accordion-container {
      width: 100%;

      .master-title-section {
        div {
          margin-bottom: 16px;

          h1 {
            font-size: 24px;
            font-weight: 600;
            line-height: 18px;
            margin-bottom: 16px;
          }
        }
      }

      .title-section {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        .title-section-left {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        h1 {
          color: #282828;
          font-size: 20px;
          font-weight: 600;
          line-height: 26px;
          text-align: left;
          margin-right: 6px;
        }
        h2 {
          font-family: Montserrat;
          font-size: 12px;
          font-weight: 500;
          line-height: 24px;
          text-align: left;
          color: #282828;
        }
        p {
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          text-align: right;
          color: #282828;
          margin: 0;
          text-wrap: nowrap;
        }
      }

      .see-more-section {
        margin-top: 4px;
        display: flex;
        align-items: center;
        cursor: pointer;

        p {
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
          text-align: left;
          margin: 0;
        }

        .chevron-container {
          height: 24px;
          width: 24px;
        }
      }

      .see-less-section {
        margin-top: 6px;
        display: flex;
        align-items: center;
        cursor: pointer;

        p {
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
          text-align: left;
          margin: 0;
        }

        .chevron-container {
          height: 24px;
          width: 24px;
          transform: rotate(180deg);
        }
      }

      .see-less-indented {
        margin-left: 16px;
      }

      .header-container {
        margin-top: 14px;
        background-color: #42947a;
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 25px;

        h1 {
          font-size: 20px;
          font-weight: 600;
          line-height: 22px;
          color: white;
        }

        .header-price {
          background-color: #ffffff;
          padding-left: 12px;
          padding-right: 12px;
          padding-top: 10px;
          padding-bottom: 10px;
          border-radius: 10px;
          h1 {
            font-size: 20px;
            font-weight: 600;
            line-height: 30px;
            text-align: center;
            color: #009677;
            text-wrap: nowrap;
          }
        }
      }

      .header-container-content-body {
        .content-title {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: #747474;

          p {
            margin: 0;
          }
        }

        .bullets-container {
          padding-bottom: 28px;
          ul {
            li {
              color: #747474;
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
            }
          }
        }
      }

      .content-section {
        width: 100%;
        margin-top: 8px;

        .content-body {
          width: 100%;

          .paragraph-section {
            p {
              margin: 0;
              font-size: 16px;
              font-weight: 400;
              line-height: 22px;
              color: #282828;
            }
          }

          .header-and-title-section.indented-header-and-title {
            padding-left: 16px;
          }
          .header-and-title-section {
            .title-part {
              margin-top: 24px;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              h1 {
                font-size: 18px;
                font-weight: 600;
                line-height: 23.4px;
                margin-bottom: 10px;
                margin-right: 6px;
              }
              h1.small-title-part {
                font-size: 16px;
                font-weight: 600;
                line-height: 22px;
              }
              p {
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
                color: #282828;
                margin: 0;
                text-wrap: nowrap;
              }
            }

            .title-part.small-gap {
              margin-top: 8px;
            }
            .title-part.reversed {
              h1 {
                font-size: 18px;
                font-weight: 600;
                line-height: 23.4px;
                margin-bottom: 10px;
              }
            }

            .subtitle {
              display: flex;

              p {
                font-size: 16px;
                font-weight: 400;
                line-height: 20.8px;
                letter-spacing: -0.01em;
                color: #282828;
                margin: 0;
              }
            }
          }

          .summary-section {
            padding-left: 10px;
          }
        }
      }
      .separator-container {
        width: 100%;
      }
      .separator {
        width: 100%;
        background-color: #dfe2e5;
        height: 1px;
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }
  }

  @media screen and (max-width: 1263px) and (min-width: 0px) {
    .in-journey-accordion {
      .in-journey-accordion-container {
        .header-container {
          flex-direction: column;
          h1 {
            margin-bottom: 10px;
            text-align: center;
          }
          .header-price {
            width: 100%;
            padding-top: 7px;
            padding-bottom: 7px;
            padding-left: 26px;
            padding-right: 26px;
            h1 {
              margin: 0;
            }
          }
        }
      }
    }

    @media screen and (max-width: 740px) and (min-width: 0px) {
      .in-journey-accordion {
        .in-journey-accordion-container {
          .title-section {
            align-items: flex-end;

            h2 {
              display: none;
            }
          }
        }
      }
    }

    @media screen and (max-width: 1263px) and (min-width: 0px) {
      .in-journey-accordion {
        .in-journey-accordion-container {
          .title-section {
            .title-section-left {
              flex-direction: column;
              align-items: flex-start;
            }

            h1 {
              margin-right: 6px;
            }
          }
        }
      }
    }
  }
</style>
